(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reference-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('reference-localization')) {
    customElements.define(
      'reference-localization',
      class ReferenceLocalization extends HTMLElement {
        connectedCallback() {
          this.trigger = this.querySelector('[data-localization-trigger]');
          this.panel = this.querySelector('[data-localization-panel]');
          this.selectorTriggers = Array.from(this.querySelectorAll('[data-selector-trigger]'));
          this.optionButtons = Array.from(this.querySelectorAll('[data-localization-option]'));
          this.searchInput = this.querySelector('[data-currency-search]');
          this.boundOutsideClick = this.handleOutsideClick.bind(this);
          this.boundKeydown = this.handleKeydown.bind(this);

          this.trigger?.addEventListener('click', () => this.togglePanel());
          this.selectorTriggers.forEach((button) => {
            button.addEventListener('click', () => this.toggleSelector(button));
          });
          this.optionButtons.forEach((button) => {
            button.addEventListener('click', () => this.selectOption(button));
          });
          this.searchInput?.addEventListener('input', () => this.filterCurrencies());
          document.addEventListener('pointerdown', this.boundOutsideClick);
          this.addEventListener('keydown', this.boundKeydown);
          this.sortCurrencies();
        }

        disconnectedCallback() {
          document.removeEventListener('pointerdown', this.boundOutsideClick);
          this.removeEventListener('keydown', this.boundKeydown);
        }

        togglePanel(forceOpen) {
          const shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : this.panel.hidden;
          this.panel.hidden = !shouldOpen;
          this.trigger.setAttribute('aria-expanded', shouldOpen.toString());
          this.trigger.classList.toggle('is-open', shouldOpen);
          this.closeSelectors();

          const stickyHeader = document.querySelector('.reference-header-shell');
          if (stickyHeader) stickyHeader.preventHide = shouldOpen;
        }

        toggleSelector(button) {
          const selector = button.closest('[data-selector]');
          const options = selector?.querySelector('[data-selector-options]');
          if (!options) return;

          const shouldOpen = options.hidden;
          this.closeSelectors();
          options.hidden = !shouldOpen;
          button.setAttribute('aria-expanded', shouldOpen.toString());

          if (shouldOpen && this.searchInput && options.contains(this.searchInput)) {
            window.requestAnimationFrame(() => this.searchInput.focus());
          }
        }

        closeSelectors() {
          this.querySelectorAll('[data-selector-options]').forEach((options) => {
            options.hidden = true;
          });
          this.selectorTriggers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        }

        selectOption(button) {
          const type = button.dataset.localizationOption;
          const inputName = type === 'language' ? 'locale_code' : 'country_code';
          const input = this.querySelector(`input[name="${inputName}"]`);
          const label = button.querySelector('[data-option-label]')?.textContent || '';
          const code = button.querySelector('[data-option-code]')?.textContent || '';
          const flag = button.querySelector('.reference-localization__flag');

          if (input) input.value = button.dataset.value;
          this.querySelectorAll(`[data-localization-option="${type}"]`).forEach((option) => {
            option.setAttribute('aria-selected', (option === button).toString());
          });

          [this.querySelector(`[data-selected-output="${type}"]`), this.querySelector(`[data-trigger-output="${type}"]`)]
            .filter(Boolean)
            .forEach((output) => {
              const outputFlag = output.querySelector('.reference-localization__flag');
              const outputLabel = output.querySelector('[data-output-label]');
              const outputCode = output.querySelector('[data-output-code]');
              if (outputFlag && flag) {
                outputFlag.replaceWith(flag.cloneNode(true));
              }
              if (outputLabel) outputLabel.textContent = label;
              if (outputCode) outputCode.textContent = code;
            });

          this.closeSelectors();
          this.trigger.focus();
        }

        filterCurrencies() {
          const query = this.searchInput.value.trim().toLocaleLowerCase();
          this.querySelectorAll('[data-localization-option="country"]').forEach((option) => {
            option.hidden = !option.dataset.search.toLocaleLowerCase().includes(query);
          });
        }

        sortCurrencies() {
          const container = this.querySelector('[data-currency-options]');
          if (!container) return;

          const options = Array.from(container.querySelectorAll('[data-localization-option="country"]'));
          options
            .sort((first, second) => {
              if (first.dataset.current === 'true') return -1;
              if (second.dataset.current === 'true') return 1;
              return first.dataset.currencyCode.localeCompare(second.dataset.currencyCode);
            })
            .forEach((option) => container.append(option));
        }

        handleOutsideClick(event) {
          if (!this.contains(event.target) && !this.panel.hidden) {
            this.togglePanel(false);
          }
        }

        handleKeydown(event) {
          if (event.key !== 'Escape') return;

          const openSelector = this.querySelector('[data-selector-options]:not([hidden])');
          if (openSelector) {
            const openTrigger = this.selectorTriggers.find(
              (button) => button.getAttribute('aria-expanded') === 'true'
            );
            this.closeSelectors();
            openTrigger?.focus();
            return;
          }

          if (!this.panel.hidden) {
            this.togglePanel(false);
            this.trigger.focus();
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
